import React from 'react';
import { Link } from 'react-router-dom';
import ronImg from '../Images/Ron_templeman.jpg';
import vladImg from '../Images/Vlad_tyshchenko.jpg';
import christineImg from '../Images/Christine_perrault.jpg';

const Company = () => {
  const teamMembers = [
    {
      name: 'Ron Templeman',
      role: 'CEO & Director',
      image: ronImg,
      expertise: ['Database Modeling', 'Data Architect', 'System Design'],
      description:
        'A seasoned expert in statistical data analysis with a Bachelor of Science in Mathematics from the University of Saskatchewan. Ron bridges the gap between pure mathematical logic and enterprise data management. Since 1986, he has mentored emerging professionals and guided institutional clients through complex decision-making frameworks.',
    },
    {
      name: 'Vlad Tyshchenko',
      role: 'Lead Software Architect',
      image: vladImg,
      expertise: ['Full-Stack Engineering', 'System Modernization', 'API Design'],
      description:
        'Holding a Master’s degree in Software Engineering, Vladyslav specializes in architecting high-performance, full-stack environments. He leads the technical execution of our custom software solutions, ensuring that every line of code serves the broader goal of system stability and scalability.',
    },
    {
  name: 'Christine Perrault',
  role: 'Technical Operations & Interface Design',
  image: christineImg,
  expertise: ['Linux Administration', 'UI/UX Design', 'Systems Security'],
  description:
    'Christine oversees the essential framework of our technical operations, managing the deployment and maintenance of Linux server environments and security protocols. Combining her focus on interface design with operational management, she ensures the ongoing integrity and technical standards of the organization’s infrastructure.'
}
  ];

  return (
    <div style={{ backgroundColor: '#fff', color: '#0f172a', fontFamily: 'Inter, sans-serif' }}>
      
      {/* ================= 1. HISTORY SECTION (THE LEGACY) ================= */}
      <section style={historySection}>
        <div style={container}>
          <span style={eyebrow}>Our Foundation</span>
          <h1 style={mainTitle}>Engineering Legacies <br/>Since 1986</h1>
          <div style={historyCard}>
            <p style={historyText}>
              Formerly known as <strong>Optima Research Inc.</strong> and <strong>Templeman Consulting</strong>, Yellow Ray Consulting Group has been a cornerstone of data-driven insights for nearly four decades. 
            </p>
            <p style={historyText}>
              What began as a specialized statistical firm has evolved into a comprehensive systems architecture group. We have spent 35+ years refining our approach to data governance, stewardship, and relational modeling—helping institutions move from fragmented information to operational certainty.
            </p>
          </div>
        </div>
      </section>

      {/* ================= 2. TEAM SECTION (THE EXPERTISE) ================= */}
      <section style={teamSection}>
        <div style={container}>
          <h2 style={sectionTitle}>Our Leadership & Faculty</h2>
          <div style={teamGrid}>
            {teamMembers.map((member, index) => (
              <div key={index} style={teamCard}>
                <div style={imageWrapper}>
                  <img src={member.image} alt={member.name} style={memberImage} />
                </div>
                <h3 style={memberName}>{member.name}</h3>
                <div style={memberRole}>{member.role}</div>
                
                {/* Expertise Badges */}
                <div style={badgeContainer}>
                  {member.expertise.map((skill, i) => (
                    <span key={i} style={skillBadge}>{skill}</span>
                  ))}
                </div>

                <p style={memberDesc}>{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= 3. CLOSING CALL TO ACTION ================= */}
      <section style={ctaSection}>
  <h2 style={{ fontSize: '24px', marginBottom: '15px' }}>
    Put our expertise to work for your organization.
  </h2>
  
  {/* Changed from <button> to <Link> */}
  <Link 
    to="/case-studies" 
    style={{ 
      ...ctaButton, 
      textDecoration: 'none', 
      display: 'inline-block' 
    }}
  >
    View Our Case Studies
  </Link>
</section>
    </div>
  );
};

// ================= STYLES =================

const container = { maxWidth: '1150px', margin: '0 auto', padding: '0 20px' };

const eyebrow = {
  color: '#007bff',
  fontWeight: '800',
  fontSize: '12px',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  display: 'block',
  marginBottom: '15px'
};

const historySection = {
  padding: '100px 0',
  backgroundColor: '#f8fafc',
  textAlign: 'center',
  borderBottom: '1px solid #e2e8f0'
};

const mainTitle = { fontSize: '48px', fontWeight: '900', marginBottom: '30px', lineHeight: '1.1' };

const historyCard = {
  maxWidth: '800px',
  margin: '0 auto',
  textAlign: 'left',
  backgroundColor: '#fff',
  padding: '40px',
  borderRadius: '16px',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
  border: '1px solid #e2e8f0'
};

const historyText = { fontSize: '17px', color: '#475569', lineHeight: '1.7', marginBottom: '20px' };

const teamSection = { padding: '100px 0', textAlign: 'center' };

const sectionTitle = { fontSize: '32px', fontWeight: '800', marginBottom: '60px' };

const teamGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
  gap: '60px', // Increased gap to give larger images breathing room
  marginTop: '40px'
};

const teamCard = {
  textAlign: 'left',
  padding: '10px', // Reduced internal padding to let the image be the star
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
};

const imageWrapper = {
  width: '220px',
  height: '220px',
  borderRadius: '20px', // More rounded for a modern look
  overflow: 'hidden',
  marginBottom: '25px',
  backgroundColor: '#f1f5f9', // Placeholder color while image loads
  border: '1px solid #e2e8f0',
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
};

const memberImage = { 
  width: '100%', 
  height: '100%', 
  objectFit: 'cover'
};

const memberName = { fontSize: '22px', fontWeight: '800', marginBottom: '5px', color: '#0f172a' };

const memberRole = { fontSize: '14px', fontWeight: '700', color: '#007bff', marginBottom: '15px', textTransform: 'uppercase' };

const badgeContainer = { display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '20px' };

const skillBadge = {
  fontSize: '11px',
  fontWeight: '700',
  backgroundColor: '#f1f5f9',
  color: '#475569',
  padding: '4px 10px',
  borderRadius: '4px'
};

const memberDesc = { fontSize: '15px', color: '#64748b', lineHeight: '1.6' };

const ctaSection = {
  padding: '80px 20px',
  textAlign: 'center',
  backgroundColor: '#0f172a',
  color: '#fff'
};

const ctaButton = {
  backgroundColor: '#007bff',
  color: '#fff',
  padding: '14px 28px',
  borderRadius: '6px',
  border: 'none',
  fontWeight: '700',
  cursor: 'pointer'
};

export default Company;